import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ReviewCard = ({ review }) => {
    return (
        <div className="p-4 md:p-5 rounded-xl bg-card border border-border">
            <div className="flex items-start gap-3 mb-3">
                <Image
                    src={review?.avatar}
                    alt={review?.avatarAlt}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full object-cover flex-shrink-0"
                />
                <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-1">
                        <h5 className="text-sm md:text-base font-medium text-foreground truncate">
                            {review?.name}
                        </h5>
                        <div className="flex items-center gap-1 px-2 py-0.5 rounded-md bg-warning/10 flex-shrink-0">
                            <Icon name="Star" size={14} className="text-warning" />
                            <span className="text-xs font-data font-medium text-warning">
                                {review?.rating?.toFixed(1)}
                            </span>
                        </div>
                    </div>
                    <p className="text-xs text-muted-foreground">{review?.date}</p>
                </div>
            </div>
            <p className="text-sm text-card-foreground leading-relaxed mb-3">
                {review?.comment}
            </p>
            {review?.images && review?.images?.length > 0 && (
                <div className="flex gap-2 overflow-x-auto scrollbar-hide">
                    {review?.images?.map((img, index) => (
                        <Image
                            key={index}
                            src={img?.url}
                            alt={img?.alt}
                            className="w-20 h-20 md:w-24 md:h-24 rounded-lg object-cover flex-shrink-0"
                        />
                    ))}
                </div>
            )}
            {review?.helpful && (
                <div className="flex items-center gap-4 mt-3 pt-3 border-t border-border">
                    <button className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">
                        <Icon name="ThumbsUp" size={14} />
                        <span>Helpful ({review?.helpful})</span>
                    </button>
                    <button className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">
                        <Icon name="MessageCircle" size={14} />
                        <span>Reply</span>
                    </button>
                </div>
            )}
        </div>
    );
};

export default ReviewCard;